import { render, staticRenderFns } from "./DialogSonstigeBelege.vue?vue&type=template&id=cb0160cc&scoped=true"
import script from "./DialogSonstigeBelege.vue?vue&type=script&lang=ts"
export * from "./DialogSonstigeBelege.vue?vue&type=script&lang=ts"
import style0 from "./DialogSonstigeBelege.vue?vue&type=style&index=0&id=cb0160cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb0160cc",
  null
  
)

export default component.exports